export default __webpack_public_path__ + "static/media/Ass 11.fd093979.png";